// Library imports
import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import styled from "styled-components";

// Local Imports
import AssetCardCustomLoader from "../../../Common/Components/AssetCardCustomLoader";

interface IAssetsCardPlaceHolder {
  loading: boolean;
  isAssetsWithoutCampaign?: boolean;
  count?: number;
}

const AssetsCardPlaceHolder = (props: IAssetsCardPlaceHolder) => {
  // Local States
  const { loading, isAssetsWithoutCampaign } = props;
  const [count, setCount] = useState(props?.count ?? 6);

  // Component Logic
  const handleResize = () => {
    // if (props?.count) {
    //   setCount(props?.count);
    // } else {
    if (window.innerWidth <= 1536) setCount(4);
    else if (window.innerWidth <= 1920) setCount(6);
    // }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize); // Add event listener
    handleResize(); // Handler to call on window resize
    return () => window.removeEventListener("resize", handleResize); // Remove event listener on cleanup
  }, []);

  return (
    <>
      {loading ? (
        <Wrapper>
          <Row gutter={{ xs: 20, sm: 30, md: 40, lg: 40, xxl: 56 }} id="audience-list-images">
            {[...Array.from(Array(count).keys(), (n) => n + 1)].map((item, index): any => (
              <Col xs={18} sm={12} md={8} lg={6} xl={6} xxl={4} key={index} className="gutter-row mb-3">
                <div key={index} className={`responsive-svg type-1 ${isAssetsWithoutCampaign ? "border-2" : ""}`}>
                  <AssetCardCustomLoader isAssetWithoutCampaign={isAssetsWithoutCampaign} />
                </div>
              </Col>
            ))}
          </Row>
        </Wrapper>
      ) : null}
    </>
  );
};

export default AssetsCardPlaceHolder;

AssetsCardPlaceHolder.defaultProps = {
  isSmallScreen: false,
};

const Wrapper = styled.div`
  .responsive-svg {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    overflow: hidden;
    position: relative;
    height: 100%;
    max-height: 280px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-height: 225px;
    }
    .preview-1 {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 96px;
      }
    }
    .preview-2 {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 48px;
      }
    }
    .preview-3 {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 48px;
      }
    }
    .details {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding: 10px 15px 0px 10px;
      }
    }
    &:before {
      // background-image: url({XiQLightLogo});
      background-repeat: no-repeat;
      background-position: center;
      top: 0;
      left: 0;
      content: "";
      position: absolute;
      height: 63%;
      width: 100%;
      z-index: 99;
    }
    svg {
      width: 100%;
      height: 100%;
      defs {
        linearGradient {
          stop {
            stop-color: #e9e9e9 !important;
            &:nth-of-type(2) {
              stop-color: #f6f6f6 !important;
            }
          }
        }
      }
    }
    &.type-1 {
      height: 100%;
      /* width: calc(100% - 25px); */
      width: 100%;
      &:before {
        height: 230px;
      }
      .profile-img {
        height: 230px;
      }
      .title-m {
        margin-top: 21px;
      }
      &.type-1-3 {
        height: 294px;
        .profile-img {
          height: 170px;
        }
        .title-m {
          margin-top: 15px;
        }
        &:before {
          height: 170px;
          background-size: 90px;
        }
      }
      &.type-1-full {
        height: 420px;
        .profile-img {
          height: 295px;
        }
        &:before {
          height: 295px;
        }
        svg {
          height: 300px;
        }
      }
      svg {
        height: 350px;
        clipPath {
          rect {
            overflow: hidden;
            &:nth-child(1) {
              y: 90%;
              height: 5%;
              width: 30%;
            }
            &:nth-child(2) {
              y: 76%;
              height: 7%;
              width: 70%;
            }
            &:nth-child(3) {
              y: 65%;
              height: 7%;
              width: 80%;
            }
            &:nth-child(4) {
              height: 60%;
              width: 100%;
            }
          }
        }
      }
    }
    &.type-2 {
      height: auto;
      width: 100%;
      &:before {
        background-size: 40px;
        top: 15px;
        left: 10px;
        height: calc(100% - 30px);
        width: 100px;
      }
    }
    &.type-3 {
      background-color: transparent;
      box-shadow: none;
      border-radius: 0px;
      height: auto;
      &:before {
        background-size: 60%;
        top: 15px;
        left: 0;
        height: calc(100% - 25px);
        width: 11%;
      }
    }
  }
  .small-three {
    height: 100%;
    flex-flow: column wrap;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
  }
  .border-2 {
    border: 2px solid #cbc2c2;
  }
`;
